import PropTypes from 'prop-types';
import { iconsList } from '../icon/glyphs';
import { TYPES as ICON_TYPES } from '../icon/constants';
import {
  APPEARANCES,
  FONT_WEIGHTS,
  FORMATS,
  ICON_PLACEMENTS,
  SIZES,
  FONT_SIZES,
} from './constants';

export const ActionButtonProps = {
  appearance: PropTypes.oneOf(Object.values(APPEARANCES)),
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  fontWeight: PropTypes.oneOf(Object.values(FONT_WEIGHTS)),
  fontSize: PropTypes.oneOf(Object.values(FONT_SIZES)),
  format: PropTypes.oneOf(Object.values(FORMATS)),
  fullWidth: PropTypes.bool,
  iconGlyph: PropTypes.oneOf(iconsList),
  iconType: PropTypes.oneOf(Object.values(ICON_TYPES)),
  iconPlacement: PropTypes.oneOf(Object.values(ICON_PLACEMENTS)),
  label: PropTypes.string,
  onClick: PropTypes.func,
  rounded: PropTypes.bool,
  size: PropTypes.oneOf(Object.values(SIZES)),
  isLoading: PropTypes.bool,
  href: PropTypes.string,
  target: PropTypes.string,
};
